module.exports = __webpack_public_path__ + "img/link_app.114dd1f6.png";